<template>
  <div v-if="entity" class="monitor-avatar-name">
    <!-- mismo criterio que el resto del sistema (pedidos, ventas): foto o inicial con color -->
    <b-avatar v-if="entity.image" :src="entity.image" :size="size"></b-avatar>
    <b-avatar v-else :size="size"
              :text="avatar.text"
              :style="avatar.style"></b-avatar>
    <span class="monitor-avatar-name__text">
      <b>{{entity.name}}</b>
      <b-badge v-if="entity.active === false || entity.active === 0" variant="danger" class="ml-1">Inactivo</b-badge>
    </span>
  </div>
  <span v-else class="text-muted">{{emptyLabel}}</span>
</template>

<script>
  import Funciones from '@/handler/funciones'

  // cliente / proveedor con avatar, para las tablas de Servidores e Instancias
  export default {
    props: {
      entity: { type: Object, default: null },  // {name, image, active}
      emptyLabel: { type: String, default: '—' },
      size: { type: String, default: '28px' },
    },
    computed: {
      avatar() {
        return Funciones.avatarFromName(this.entity ? this.entity.name : '')
      },
    },
  }
</script>

<style scoped>
  .monitor-avatar-name {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .monitor-avatar-name__text {
    min-width: 0;
    line-height: 1.2;
  }
</style>
